<template>
  <div class="spinner-border text-secondary" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</template>

<script>
export default {}
</script>
